/*
	Utility to help measure startup performance.
*/
iaw.perf = {

	timers: {
		DataTime: 'all data loaded',
		HostData: 'host data',
		HostPresetData: 'host preset data',
		PSDKData: 'psdk data',
		StockData: 'stock data',
		LicensedData: 'licensed templates',
		LoadLibraryFile: 'CC Libraries script load',
		InitLibrary: 'CC Libraries init',
		RetrieveLicensedTemplate: 'retreive licensed template',
		TemplateFixup: 'template fixup',
		InitHost: 'host init',
		InitStock: 'stock init',
		JSLibLateLoad: 'JS scripts late load',
		InitLicensed: 'licensed templates init',
		UI: 'UI scripts load',
		LoadTime: 'total load time',
		InteractiveTime: 'interactive ready',
		FinalizeData: 'finalize all data',
		RenderTime: 'render time',
		StockDataRequest: 'stock data request',
		PostStockData: 'postprocess stock data',
		CORELIBS: 'data store lib & iaw load',
		INGESTCONFIG: 'Ingest config',
		Sidebar: 'Product Sidebar'
	},

	_timers: {},
	_startMark: 0,
	_measures: [],
	_logToHighBeam: false,

	/**
	 * Private method for calculating the global delta off the last set start mark.
	 *
	 * @return {Number} containing the global delta value.
	 */
	_globalDelta: function() {
		var now = window.performance.now();
		var delta = 0;

		if (this._startMark) {
			delta = Math.round(now - this._startMark);
		}
		return delta;
	},

	/**
	 * Set an optional start mark. If this is set then all measures will include
	 * a global delta time from the start mark.
	 *
	 * @param start 		time mark to start from
	 */
	markStart: function(start) {
		this._startMark = start || window.performance.now();
	},

	/**
	 * Enable HighBeam performance logging.
	 *
	 * @param enabled 		{Boolean} enablement flag
	 * @param category 		{String} HighBeam category identifier (required)
	 */
	setHighBeamMode: function(enabled, category) {
		if (!category) {
			console.log('CCX-Performance: Error \'category\' parameter is required for HighBeam perfromance logging, data will not be sent.');
			this._logToHighBeam = false;
			return;
		}
		this._logToHighBeam = enabled;
		this._highBeamCategory = category;
	},

	/**
	 * Set a timer mark.
	 *
	 * @param strID		string ID for timer
	 */
	set: function(strID) {
		console.time(strID);
		this._timers[strID] = window.performance.now();
		this._measures.push({
			mode: 'set',
			id: strID,
			globalDelta: this._globalDelta()
		});
	},

	/**
	 * Determine the delta between the set mark an now.
	 *
	 * @param strID		string ID for timer mark
	 * @param startup	Optional start timing in case it wasn't measure with `set`
	 */
	measure: function(strID, start) {
		var now = window.performance.now();
		if (!start) {
			console.timeEnd(strID);
		}
		else {
			console.debug(strID + ': ' + (now - start) + 'ms');
		}

		if (!this._timers[strID] && !start) {
			console.log('[perf.measure] metric for key: \''+strID+'\' was not set - ignoring measure mark');
			return;
		}
		start = start || this._timers[strID];

		var measure = {
			mode: 'measure',
			id: strID,
			deltaT: Math.round(now - start),
			globalDelta: this._globalDelta()
		};

		this._measures.push(measure);
	},

	/**
	 * Report out all measurements to the log and optionally to HighBeam.
	 *
	 * @param clearMeasures		{Boolean} value to clear stored measures after report
	 */
	report: function(clearMeasures) {
		var count = this._measures.length;
		var pipDataGroup = {};

		console.log('[perf.report] ----------------------------------------------');
		for (var index = 0; index < count; ++index) {
			var measure = this._measures[index];
			var message = null;

			if (measure.mode === 'measure') {
				message = '[perf.measure] '+ measure.id+': '+measure.deltaT+' ms (global: '+measure.globalDelta+' ms)';
				pipDataGroup[measure.id] = measure.deltaT;
			}
			else {
				message = '[perf.set] mark for: '+measure.id+' (global: '+measure.globalDelta+' ms)';

			}
			console.log(message);
		}
		if (this._logToHighBeam) {
			iaw.analytics.pip.logDataGroupEvent('Startup Performance', pipDataGroup, this._highBeamCategory, 'performance');
		}
		// remove all measures if requested
		if (clearMeasures) {
			this._measures.length = 0;
		}
	}
};
